<template>
  <div class="bg-white">
    <div
      v-if="getBadgeText(date)"
      class="h-5 px-2 flex items-center rounded-md text-xs"
      :class="`${getBadgeText(date)!.className}`"
    >
      {{ getBadgeText(date)!.text }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { EventDate } from '~/composables/types/event'

defineProps<{
  date: EventDate
}>()

const { t } = useI18n()

const getBadgeText = (date: EventDate) => {
  if (eventDateGetters.getDateIsSoldOut(date)) {
    return {
      className: 'bg-gray-200 border-gray-500 text-gray-500',
      text: t('product.status.soldOut'),
    }
  }
  if (eventDateGetters.getAvailableTicketsQuantity(date) <= 4) {
    return {
      className: 'bg-orange-600 border-red-500 text-white',
      text: t('product.show.timeSlots.sellingOutBadgeText'),
    }
  }
}
</script>
